export default "__VITE_ASSET__CGmRZFcw__"